<template>
	<div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
		<div class="tw-text-4xl tw-font-bold">{{ minutes }}:{{ seconds }}</div>
	</div>
</template>

<script setup lang="ts">
import {ref, watch, onMounted} from "vue";

const props = defineProps({
	totalSeconds: {
		type: Number,
		required: true,
	},
});

const minutes = ref<string>("00");
const seconds = ref<string>("00");
const remainingSeconds = ref<number>(props.totalSeconds);

const updateTimer = () => {
	const mins = Math.floor(remainingSeconds.value / 60);
	const secs = remainingSeconds.value % 60;
	minutes.value = mins.toString().padStart(2, "0");
	seconds.value = secs.toString().padStart(2, "0");
};
const emit = defineEmits(["end"]);
watch(
	() => props.totalSeconds,
	(newTotalSeconds) => {
		remainingSeconds.value = newTotalSeconds;
		updateTimer();
	}
);

onMounted(() => {
	updateTimer();
	const interval = setInterval(() => {
		if (remainingSeconds.value > 0) {
			remainingSeconds.value -= 1;
			updateTimer();
		} else {
			clearInterval(interval);
			emit("end");
		}
	}, 1000);
});
</script>